import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = 'inventory';

class InventoryService {
  getMarketplaceItemInventory = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/items`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching inventory items.');
    }
  };

  generateInventoryFile = async type => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/file?type=${type}`, {
        responseType: type === 'xlsx' ? 'blob' : 'json',
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching generated inventory file.');
    }
  };
}
const inventoryService = new InventoryService();

export default inventoryService;
